import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=6a0f31e9&scoped=true&"
import script from "./SVGIcon.vue?vue&type=script&lang=js&"
export * from "./SVGIcon.vue?vue&type=script&lang=js&"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=6a0f31e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f31e9",
  null
  
)

export default component.exports